
/* injects from baggage-loader */

'use strict'

//import $ from "jquery";

import { genSecureHex } from '_appRoot/core/services/secure-random';

import { TrunkIcons, initFeedbackTexts, feedbackTexts, helpTpl, level1SelectedMonkey1, level1SelectedMonkey2, level2SelectedMonkey1, level2SelectedMonkey2 } from './stage-three.const';

import { shuffle, random, findIndex } from 'lodash';


export default class StageThreeController {
    constructor($log, $rootScope, $state, $timeout, Dialog, Session) {
        'ngInject';

        //super(Session);
        this.name = "Stage 3";
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.Dialog = Dialog;
        this.Session = Session;

        this.trunk = {
            images: {
                default: TrunkIcons.default,
                submerged: TrunkIcons.submerged
            }
        }

        this.selected_monkey = 0;
        this.wrong_jump = false;


        this.monkey = [
            {
                image: require('_images/stages/stage-three/monkey-son.png'),
                imageDefault: require('_images/stages/stage-three/monkey-son.png'),
                imageBanana: require('_images/stages/stage-three/monkey-son-banana.png'),
                start: 100,
                place: 0,
                pos: 100,
                jump: 75,
                range: 2
            },
            {
                image: require('_images/stages/stage-three/monkey-dad.png'),
                imageDefault: require('_images/stages/stage-three/monkey-dad.png'),
                imageBanana: require('_images/stages/stage-three/monkey-dad-banana.png'),
                start: 70,
                place: 0,
                pos: 70,
                jump: 75,
                range: 3
            }
        ];

        this.step = 1;


        this.state = {
            totalItems: 0,
            trashInFocus: false
        };


        this.trunks = [];
        this.trunksDad = [];

        this.model = {
            level: 1,
            selected_monkey: this.selected_monkey,
            trunk: 0,
            numberFirstTrunk: 0
        };
    }

    $onInit() {
        let updates = this.Session.get();
        let stageIndex = findIndex(updates.stages, { name: this.name });
        //console.log(updates);
        //console.log(this.name);

        //console.log(stageIndex);
        //this.trunks = this.createTrunk();
        updates.stages[stageIndex].timesEntered++;

        this.Dialog.showFeedbackIbama('label-macaco', initFeedbackTexts, () => {

            if (updates.stages[stageIndex].firstRun) {
                console.log("entrou!!!");
                updates.stages[stageIndex].firstRun = false;
                this.Session.save(updates);
                this.Dialog.showBigAlert('label-help', helpTpl, () => {
                    this.initialization();
                });
            }
            else {
                this.Session.save(updates);
                this.initialization();
            }
        });
    }

    initialization() {
        this.Dialog.showSelectMonkey(this, () => {
            this.model.selected_monkey = this.selected_monkey--;
            switch (this.selected_monkey) {
                case 0:
                    this.Dialog.showFeedbackIbama('label-macaco', level1SelectedMonkey1);
                    break;

                case 1:
                    this.Dialog.showFeedbackIbama('label-macaco', level1SelectedMonkey2);
                    break;
            }
            this.trunks = this.createTrunk();
            this.step++;
        });
    }

    $onDestroy() {
        this.$rootScope.$emit('modal.closing');
    }

    openHelp() {
        this.Dialog.showBigAlert('label-help', helpTpl);
    }

    createTrunk(num) {
        let items = [];
        num = parseInt(num);
        if (isNaN(num)) num = 0;

        for (let i = 0; i < 13; i++) {
            let item = {
                id: genSecureHex(),
                clicked: false,
                number: (num + i),
                pos: 0,
                images: TrunkIcons.default
            }

            items.push(item);
        }

        return items;
    }

    monkeyJump(index) {
        let distance = index - this.monkey[this.selected_monkey].place;


        if (index !== 0 && this.trunks[index].clicked === false && distance < this.monkey[this.selected_monkey].range + 2 && this.monkey[this.selected_monkey].place < index) {
            let mnk = document.getElementById('monkey-player');

            this.monkey[this.selected_monkey].pos = this.monkey[this.selected_monkey].pos + (this.monkey[this.selected_monkey].jump * distance);
            this.monkey[this.selected_monkey].place = this.monkey[this.selected_monkey].place + distance;
            mnk.style.left = this.monkey[this.selected_monkey].pos + 'px';



            if ((index % this.monkey[this.selected_monkey].range)) {
                this.wrong_jump = true;
                this.$timeout(() => {
                    this.trunks[index].images = this.trunk.images.submerged;
                    this.animateLog(this.trunks[index].id);

                    this.monkey[this.selected_monkey].pos = this.monkey[this.selected_monkey].start;
                    this.monkey[this.selected_monkey].place = 0;
                    mnk.style.left = this.monkey[this.selected_monkey].pos + 'px';
                    this.trunks[index].clicked = true;
                    this.wrong_jump = false;

                }, 600);
            } else if (this.monkey[this.selected_monkey].place === 12 && !this.wrong_jump) {
                this.$timeout(() => {
                    this.monkey[this.selected_monkey].pos = this.monkey[this.selected_monkey].pos + 80;
                    mnk.style.left = this.monkey[this.selected_monkey].pos + 'px';
                    this.monkey[this.selected_monkey].image = this.monkey[this.selected_monkey].imageBanana;
                    this.$timeout(() => {
                        this.question(mnk, this.model.level);
                    }, 700);
                }, 600);
            }
        }
    }

    question(mnk, level) {
        switch (level) {
            case 1:
                document.getElementById(this.trunks[this.trunks.length - 1].id).style.zIndex = 2000;
                mnk.style.zIndex = 2000;
                //refTrunk.style.zIndex = 2000;
                this.Dialog.showQuizMacaco('label-responda', this.model, () => false, () => {


                    for (let i = 0; i < this.trunks.length; i++) {
                        let elemTrunk = document.getElementById(this.trunks[i].id);
                        elemTrunk.style.top = "";
                        elemTrunk.style.zIndex = "";
                    }
                    mnk.style.zIndex = "";
                    this.monkey[this.selected_monkey].place = 0;
                    this.monkey[this.selected_monkey].image = this.monkey[this.selected_monkey].imageDefault;
                    this.step--;
                    this.model.level++;

                    this.Dialog.showSelectMonkey(this, () => {
                        this.model.selected_monkey = this.selected_monkey--;
                        switch (this.selected_monkey) {
                            case 0:
                                this.Dialog.showFeedbackIbama('label-macaco', level2SelectedMonkey1, () => false);
                                break;

                            case 1:
                                this.Dialog.showFeedbackIbama('label-macaco', level2SelectedMonkey2, () => false);
                                break;
                        }
                        this.model.numberFirstTrunk = 0;
                        let numTentativas = 0;
                        while(this.model.numberFirstTrunk === 0 || (this.model.numberFirstTrunk % (this.selected_monkey + 2) !== 0)){
                            this.model.numberFirstTrunk = random(102, 150, false);
                            console.log("Número tentativas: ", ++numTentativas);
                        }
                        this.trunks = this.createTrunk(this.model.numberFirstTrunk);
                        this.monkey[this.selected_monkey].pos = this.monkey[this.selected_monkey].start;
                        mnk.style.left = this.monkey[this.selected_monkey].pos + "px";
                        this.step++;
                    });
                });
                break;

            case 2:
                this.model.trunk = this.trunks[0].id;
                document.getElementById(this.trunks[0].id).style.zIndex = 2000;
                mnk.style.zIndex = 2000;
                this.Dialog.showQuizMacaco('label-responda', this.model, () => false);
                break;
        }
    }

    animateLog(id) {
        let elem = document.getElementById(id);
        let pos = 0;
        let interval = setInterval(frame, 5);

        function frame() {
            if (pos === 80) {
                clearInterval(interval);
            } else {
                pos++;

                elem.style.top = pos + "px";

            }
        }



    }

    onDrop($event, data, items, type) {
        if (type === data.type) {
            let indexOf = findIndex(items, { id: data.id });
            this.model[data.type].push(data);
            this.items.splice(indexOf, 1);

            if (this.isValid()) {
                this.$timeout(() => {
                    this.Dialog.showFeedback('label-very-good', feedbackTexts, 'btn-continue', this.onShowFeedbackSuccess.bind(this));
                }, 1200);
            }
        }
    }

    dropValidate(type, data) {
        return type === data.type;
    }


    // Feedback callbacks
    onShowFeedbackSuccess() {
        this.$timeout(() => {
            this.state.trashInFocus = true;
            this.Dialog.showGraphOnca(this.model, this.onShowGraphOnca.bind(this))
        }, 1200);
    }

    onShowGraphOnca() {
        this.state.trashInFocus = false
    }

    // Generators

    createItems() {

        let quantities = [random(1, 6, false), random(1, 6, false), random(1, 6, false)];
        quantities = shuffle(quantities);

        let glass = this.createItem('glass', quantities[0]);
        let paper = this.createItem('paper', quantities[1]);
        let metal = this.createItem('metal', quantities[2]);

        let items = [];

        items = items.concat(glass);
        items = items.concat(metal);
        items = items.concat(paper);

        this.items = shuffle(items);
        this.state.totalItems = this.items.length;
    }


    createItem(type, total) {
        let items = [];

        if (!total) {
            total = random(3, 5, false);
        }

        for (let i = 0; i < total; i++) {
            let item = {
                id: genSecureHex(),
                type: type,
                images: {
                    default: TrunkIcons[type].default,
                    submerged: TrunkIcons[type].submerged
                }
            }

            items.push(Object.assign(this.createItemPosition(), item));
        }

        this.trunks = items;
    }



    createItemPosition() {
        return {
            position: {
                top: `${random(200, 500)}px`,
                left: `${random(25, 100)}px`
            }
        }
    }

    isValid() {
        let totalModelItems = 0;

        angular.forEach(this.model, object => {
            totalModelItems += object.length;
        });

        return this.state.totalItems === totalModelItems;
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/stage-three/stage-three.controller.js